export default __webpack_public_path__ + "static/desktop_sek2_KV05-c6224c77d94091ee7ffd53e60dbd0d15.mp4";